module.exports = __webpack_public_path__ + "img/slider_12.ea159253.jpg";